<template>
  <div>
    <form class="mt-2" id="form-modal">
      <!-- description Notes -->
      <div class="form-group">
        <label class="label-form">Note<span style="color: red">*</span>:</label>
        <textarea class="form-control" style="height: 200px" v-model="note_description"
          placeholder="write a note here for this Demo">
          {{ getNote }}</textarea>
        <br />
        <div>
          <!-- buttons -->
          <div class="text-right mb-3">
            <!-- <button type="button" class="btn btn-secondary text-light btn-sm" data-dismiss="modal">
              Cancel
            </button> -->

          <button v-if="flag" type="button" :style= "[isMiniLoading ? { 'cursor' : 'default' } : { 'cursor' : 'pointer' }]" :disabled="isMiniLoading"  class="btn btn-block btn-success py-2 text-light btn-sm ml-2" @click="save">
            <font-awesome-icon v-if="isMiniLoading" icon="spinner" style="animation: spin 2s linear infinite; position: absolute; right: 40%; margin-top: 3px;" />
            Save
          </button>
            <button v-else type="button" :style= "[isMiniLoading ? { 'cursor' : 'default' } : { 'cursor' : 'pointer' }]" :disabled="isMiniLoading" class="btn btn-success btn-block py-2 text-light btn-sm ml-1" @click="updateNormalNote">
            <font-awesome-icon v-if="isMiniLoading" icon="spinner" style="animation: spin 2s linear infinite; position: absolute; right: 40%; margin-top: 3px;" />
            Update
            </button>
          </div>
          <table class="table table-bordered table-hover">
            <colgroup>
              <col class="col-md-4" />
              <col class="col-md-12" />
            </colgroup>
            <tbody>
              <tr class="mt-2" v-for="(demo, index) in demo_notes" :key="demo.id">
                <td style="width: 30%;">
                  <span style="font-weight: bold">{{ demo.created_at | formatDate}}</span>
                </td>
                <td  style="width: 60%;"> <p style="white-space: break-spaces">{{ demo.note }}</p> </td>
                <td  style="width: 10%;">
                  <div class="btn-group">
                    <a class="btn dropdown-toggle" data-toggle="dropdown" href="#">
                      <span class="fas fa-ellipsis-v"></span>
                    </a>
                    <ul class="dropdown-menu" style="min-width: 12rem !important">
                      <a class="dropdown-item" @click="updateIndex(index)">Edit</a>
                      <a class="dropdown-item " style="color: rgb(247, 7, 7);" @click="deleteNormalNote(demo.id)">Delete</a>
                    </ul>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

     
    </form>
  </div>
</template>

<script>
  // import Multiselect from 'vue-multiselect';
  import axios from "axios";
  import moment from "moment";

  Vue.filter("formatDate", function (value) {
    if (value != "0000-00-00 00:00:00" && value != null) {
      return moment(String(value)).format("MMM DD, Y LT");
    }
  });
  export default {
    props: ["action", "formData", "pageNumber"],
    data: function () {
      return {
        note_description: "",
        demo_notes: "",
        cursor:"pointer",
        isMiniLoading: false,
        temp_note: "",
        current_date: new Date(),
        id: "",
        flag: true,
      };
    },

    computed: {
      getNote: function () {
        this.note_description = "";
          const permission = {
        headers: {
          'X-Permission': 'lead_notes' 
        }
      };
        axios
          .get("/admin/users/get-normal-note?user_id=" + this.formData.user,permission)
          .then((response) => {
            let data = response.data.demo_notes;
            if (data != null) {
              this.demo_notes = data;
            }
            this.flag = true;
          });
      },
    },

    methods: {
      save() {
        this.isMiniLoading = true;
        let page_no = this.formData.pageNumber;
        let self = this;
        let note = self.note_description;
        if (note.replace(/\s/g, "").length) {
            const permission = {
        headers: {
          'X-Permission': 'lead_notes' 
        }
      };
          axios
            .post("/admin/users/save-demo-note", {
              demo_id: self.formData.user,
              note: note,
            },permission)
            .then(() => {
              this.$toast.success("Note has been added successfully");
              this.isMiniLoading = false;
              // window.$("#modal").modal("hide");
              this.note_description = "";
              this.getNormalNote();
              this.$store.dispatch("users/getAllDemoRequests", [
                page_no,
                "",
                this.formData.status,
                "",
                "",
                "",
                "",
                "",
                "",
                this.formData.color ? this.formData.color : "",
                this.formData.followup_filter,
                'all',
                'all',
              ]);
            })
            .catch((error) => {
              this.$toast.error(error);
              this.isMiniLoading = false;
            });
        } else {
          this.$toast.warning("Please Fill All Required Fields");
          this.isMiniLoading = false;
        }
      },
      updateIndex(demo_id) {
        this.id = this.demo_notes[demo_id].id;
        this.note_description = this.demo_notes[demo_id].note;
        this.flag = false;
      },
      deleteNormalNote(note_id){
         const permission = {
        headers: {
          'X-Permission': 'lead_delete' 
        }
      };
         axios.get("/admin/users/get-normal-note?note_id=" + note_id,permission)
          .then(() => {
            this.$toast.success("Note Deleted successfully");
            this.getNormalNote();
          });
          this.$store.dispatch("users/getAllDemoRequests", [page_no, "", this.formData.status, "", "", "", "", "", "", this.formData.color ? this.formData.color : "", this.formData.followup_filter]);
      },
      updateNormalNote() {
         this.isMiniLoading = true;
        let page_no = this.formData.pageNumber;
        let note = this.note_description;
        let demo_id = this.id;
        if (note.replace(/\s/g, "").length) {
           const permission = {
        headers: {
          'X-Permission': 'lead_notes' 
        }
      };
          axios
            .post("/admin/users/update-normal-note", { id: demo_id, note: note },permission)
            .then(() => {
               this.isMiniLoading = false;
              this.$toast.success("Note Updated successfully");
              this.note_description = "";
              this.flag = true;
              this.getNormalNote();
              this.$store.dispatch("users/getAllDemoRequests", [
                page_no,
                "",
                this.formData.status,
                "",
                "",
                "",
                "",
                "",
                "",
                this.formData.color ? this.formData.color : "",
                this.formData.followup_filter
              ]);
            })
            .catch((error) => {
              this.isMiniLoading = false;
              this.$toast.error(error);
            });
        } else {
           this.isMiniLoading = false;
          this.$toast.warning("Please Fill All Required Fields");
        }
      },
      getNormalNote() {
       const permission = {
        headers: {
          'X-Permission': 'lead_notes' 
        }
      };
        axios
          .get("/admin/users/get-normal-note?user_id=" + this.formData.user,permission)
          .then((response) => {
            let data = response.data.demo_notes;
            if (data != null) {
              this.demo_notes = data;
            }

            this.demo_date = new Date().toISOString().slice(0, 10);
           
          });
      },
    },
  };
</script>